export const LISTING_PERFORMANCE_METRIC = {
  applications: 'applications',
  days: 'days',
  inquiries: 'inquiries',
  viewings: 'viewings',
}

export const LISTING_PERFORMANCE_METRIC_LABEL_KEY = {
  [LISTING_PERFORMANCE_METRIC.applications]:
    'RentalPortal.ListingProfilePerformanceApplicationsLabelKey',
  [LISTING_PERFORMANCE_METRIC.inquiries]:
    'RentalPortal.ListingProfilePerformanceInquiriesLabelKey',
  [LISTING_PERFORMANCE_METRIC.viewings]:
    'RentalPortal.ListingProfilePerformanceViewingsLabelKey',
}

export const LISTING_PERFORMANCE_DAYS_LABEL = {
  live: 'live',
  toLet: 'to_let',
}

export const LISTING_PERFORMANCE_DAYS_LABEL_KEY = {
  [LISTING_PERFORMANCE_DAYS_LABEL.live]:
    'RentalPortal.ListingProfilePerformanceDaysLiveLabelKey',
  [LISTING_PERFORMANCE_DAYS_LABEL.toLet]:
    'RentalPortal.ListingProfilePerformanceDaysToLetLabelKey',
}

export const LISTING_PERFORMANCE_TILE_COUNT = 4
